import { showAlertCallout } from "@/shared/alerts";

export const showHttpErrorAlertCallout = ({
  error,
  defaultErrorMessage,
}: { error: string; defaultErrorMessage?: string }) => {
  showAlertCallout({
    type: "critical",
    title: error ?? defaultErrorMessage,
  });
};
